import React, { Suspense, lazy } from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
// Lazy-load below-the-fold sections to shrink initial JS bundle and speed up first paint.
// (We deliberately do NOT use `content-visibility: auto` because it causes visible
// scroll jumps when section heights don't match their reserved placeholder.)
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const ProductIntro = lazy(() => import('./components/ProductIntro').then(m => ({
  default: m.ProductIntro
})));
const MethodPillars = lazy(() => import('./components/MethodPillars').then(m => ({
  default: m.MethodPillars
})));
const WhatsIncluded = lazy(() => import('./components/WhatsIncluded').then(m => ({
  default: m.WhatsIncluded
})));
const TransformationSection = lazy(() => import('./components/TransformationSection').then(m => ({
  default: m.TransformationSection
})));
const AudienceSection = lazy(() => import('./components/AudienceSection').then(m => ({
  default: m.AudienceSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const FloatingCTA = lazy(() => import('./components/FloatingCTA').then(m => ({
  default: m.FloatingCTA
})));
const RecentPurchaseToast = lazy(() => import('./components/RecentPurchaseToast').then(m => ({
  default: m.RecentPurchaseToast
})));
const BundleUpsellPopup = lazy(() => import('./components/BundleUpsellPopup').then(m => ({
  default: m.BundleUpsellPopup
})));
export function App() {
  return <div className="min-h-screen w-full" data-id="element-0">
      <TopBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <Suspense fallback={null} data-id="element-3">
        <FloatingCTA data-id="element-4" />
        <RecentPurchaseToast data-id="element-5" />
        <BundleUpsellPopup data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <ProductIntro data-id="element-8" />
        <MethodPillars data-id="element-9" />
        <WhatsIncluded data-id="element-10" />
        <TransformationSection data-id="element-11" />
        <AudienceSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FinalCTA data-id="element-14" />
        <Footer data-id="element-15" />
      </Suspense>
    </div>;
}